export const sanitizeAttributeIndexValue = (indexValue: string): string => {
  let sanitizedValue = indexValue || "";

  // Remove surrounding quotes if present
  if (sanitizedValue.startsWith('"') && sanitizedValue.endsWith('"')) {
    sanitizedValue = sanitizedValue.substring(1, sanitizedValue.length - 1);
  }

  // Replace |9999999998| with "
  sanitizedValue = sanitizedValue.replace(/\|9999999998\|/g, '"');

  // Replace ---- with |
  sanitizedValue = sanitizedValue.replace(/----/g, "|");

  return sanitizedValue;
};
